import { render, staticRenderFns } from "./transaction-action-column.vue?vue&type=template&id=c85cd9d8&scoped=true"
import script from "./transaction-action-column.vue?vue&type=script&lang=js"
export * from "./transaction-action-column.vue?vue&type=script&lang=js"
import style0 from "./transaction-action-column.vue?vue&type=style&index=0&id=c85cd9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85cd9d8",
  null
  
)

export default component.exports